import { render, staticRenderFns } from "./PartialReview.vue?vue&type=template&id=f79096ee&scoped=true&lang=html"
import script from "./PartialReview.vue?vue&type=script&lang=js"
export * from "./PartialReview.vue?vue&type=script&lang=js"
import style0 from "./PartialReview.vue?vue&type=style&index=0&id=f79096ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79096ee",
  null
  
)

export default component.exports